// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"98edd3aa","455":"19a3f903","457":"48362022","617":"306d753a","640":"c3c2dd20","828":"5ea15659","851":"bdc4c3be","950":"e54098aa","977":"0c991dfa"}[chunkId] + ".chunk.js";
};